var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('template',{slot:"renderEmpty"},[_c('custom-no-data',{attrs:{"text":"暂无数据"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }